import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconTrash: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="trash">
    <path d="M9.6 17.6v-6.2H8.4v6.2zm3-6.2v6.2h-1.2v-6.2zm3 6.2v-6.2h-1.2v6.2z" />
    <path
      fillRule="evenodd"
      d="M10 2.9a2.6 2.6 0 0 0-2.598 2.5H6a2.1 2.1 0 0 0-.6 4.113V18A2.6 2.6 0 0 0 8 20.6h8a2.6 2.6 0 0 0 2.6-2.6V9.513A2.1 2.1 0 0 0 18 5.4h-1.402A2.6 2.6 0 0 0 14 2.9zm0 1.2a1.4 1.4 0 0 0-1.397 1.3h6.793A1.4 1.4 0 0 0 14 4.1zM5.1 7.5a.9.9 0 0 1 .9-.9h12a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9m12.3 2.1H6.6V18A1.4 1.4 0 0 0 8 19.4h8a1.4 1.4 0 0 0 1.4-1.4z"
      clipRule="evenodd"
    />
  </Icon>
);
